export enum FileTypes {
    Pdf = 'pdf'
}
